/* eslint-disable-next-line primer-react/no-deprecated-flash -- Existing Flash usage should be migrated to Banner. */
import {Flash} from '@primer/react'
import {ChecksSection} from './ChecksSection'
import type {MergeabilityData} from '../use-mergeability-data'
import styles from './PendingChecksBody.module.css'

interface PendingChecksBodyProps {
  data: MergeabilityData
  /** Message shown when there are no individual checks to list yet */
  emptyMessage: string
  emptyMessageVariant?: 'default' | 'neutral'
  itemName: string
  transparentBackground?: boolean
}

// Shared body for the pending checks For You items - renders the full checks list,
// or an explanatory message when no individual checks have been reported yet
export function PendingChecksBody({
  data,
  emptyMessage,
  emptyMessageVariant = 'default',
  itemName,
  transparentBackground,
}: PendingChecksBodyProps) {
  const {mergeBoxPullRequest, statusChecks, statusRollup} = data

  if (statusChecks.length === 0) {
    return emptyMessageVariant === 'neutral' ? (
      <p className={styles.EmptyMessage}>{emptyMessage}</p>
    ) : (
      <Flash className="tmp-m-3" variant="default">
        {emptyMessage}
      </Flash>
    )
  }

  return (
    <ChecksSection
      statusChecks={statusChecks}
      mergeBoxPullRequest={mergeBoxPullRequest}
      statusRollup={statusRollup}
      itemName={itemName}
      transparentBackground={transparentBackground}
    />
  )
}
